/**
 * ETag spelling shared by every Azure Storage surface (S8 review fixes D, opus F10): listing ETags are unquoted, HEAD
 * ETags quoted, and a weak ETag carries `W/` — the same version in each case (NOTES «S8: live-probed facts» A6). The
 * version the copy names (dialogs, MCP approvals) is the bare ETag's last eight characters after an ellipsis.
 */

/** The ETag without its weak prefix and quotes. */
export const bareEtag = (etag: string): string => etag.replace(/^W\//u, '').replace(/^"|"$/gu, '');

export const sameEtag = (a: string, b: string): boolean => bareEtag(a) === bareEtag(b);

/** The version shown in the copy ("version …B2C3D4E5"); an ETag of ten characters or fewer is shown whole. */
export function shortEtag(etag: string): string {
  const bare = bareEtag(etag);
  return bare.length > 10 ? `…${bare.slice(-8)}` : bare;
}
